import type { TypographyVariantProps } from "../../atoms/typography";
import type { TooltipVariant } from "./types";

/** Container background classes per variant. */
export const tooltipContainerClasses: Record<TooltipVariant, string> = {
  default: "bg-luce-neutral-background-default",
  primary: "bg-luce-brand-primary",
};

/**
 * Arrow fill class per variant, matching the container background. The arrow
 * is an SVG on both platforms, and each points it per side itself.
 */
export const tooltipArrowClasses: Record<TooltipVariant, string> = {
  default: "fill-luce-neutral-background-default",
  primary: "fill-luce-brand-primary",
};

type TypographyColor = NonNullable<TypographyVariantProps["color"]>;

/** Typography color token per variant — passed to `Typography`'s `color` prop. */
export const tooltipTextColor: Record<TooltipVariant, TypographyColor> = {
  default: "neutral-foreground-default",
  primary: "brand-on-primary",
};

/**
 * Base classes shared across variants — padding, radius, shadow, and max width.
 * Pairs with `tooltipContainerClasses[variant]` for full styling.
 */
export const tooltipContentBase = "p-spacing-md rounded-radius-md shadow-card max-w-tooltip z-[60]";

/** Default distance from the trigger to the arrow (px); the arrow adds its height. */
export const tooltipSideOffset = 8;
